// extracted by mini-css-extract-plugin
export default {"textLabels":"EmailAndPassword_textLabels__FNK4y","changeButton":"EmailAndPassword_changeButton__-b0Kc"};